<template>
  <div class="wizard-request-data-candidate">
    <img id="logoGlobalwork" class="logo-request-data-canddiate" src="https://res.cloudinary.com/dhcti0lrk/image/upload/v1594399139/globalwork_gnheub.png" alt="Responsive image">
    <template v-if="viewGreeting">
      <div id="greatingText" class="wizard-request-data-candidate" >
        <p id="greatText">¡Muchas gracias por tu información!</p>
        <p id="explainGreat">
          Recuerda que toda tu información es confidencial y será tratada de acuerdo a la ley de protección de Habeas data.
        </p>        
        <p id="explainGreat">
          Somos Globalwork, una compañía que tiene propósito consolidar vínculos confiables entre las empresas y el talento humano
        </p>
      </div>
      <div class="greeting-message" id="aboutUs" style="position: relative; top: 25vh; text-align: center; padding-left: 14%">
        <img id="serviceImg" src="https://www.globalwork.co/wp-content/uploads/2020/05/icon-verificacion-antecedentes-home.svg" alt="">
        <p id="firstInformativeText">
          Quieres saber más sobre nosotros?
        </p>
        <a href="https://www.globalwork.co/" style="padding-right: 208px;">
          Ingresa aquí
        </a>  
      </div>      
    </template>
    <template v-else>
      <template v-if="project != null">         
        <form-wizard v-if="legal" ref="wizard"
          nextButtonText="Siguiente"
          backButtonText="Anterior"
          finishButtonText="Finalizar"
          color="#5F0091"
          >
          <p id="title-forms-wizard" slot="title" class="explain-tab">Hola, somos Globalwork, la empresa encargada de verificar tu información en el proceso de selección que llevas con EMPRESA. Por favor, compártenos los siguientes datos tal como están en la hoja de vida que presentaste para la vacante. Toda la información será verificada con las fuentes proporcionadas para darle continuidad al proceso de selección.</p>
          <p id="title-forms-wizard" slot="title" class="explain-tab">
            Si tienes alguna duda, puedes comunicarte con nosotros al número (+57) 3204725921 o en <a href="www.globalwork.co">www.globalwork.co</a>
          </p>
          <tab-content title="Datos de identificación">
            <basic-information-form :source="source" :project="project"></basic-information-form>
          </tab-content>
          <tab-content title="Información académica">
            <academic-references-form :project="project" :assignments="assignments" :academic_references="academic_references" :cities="cities" v-if="academic_references != null && cities != null"></academic-references-form>      
          </tab-content>
          <tab-content title="Referencias laborales">
            <laboral-references-form :project="project" :assignments="assignments" :laboral_references="laboral_references" :cities="cities" v-if="academic_references != null && cities != null"></laboral-references-form>      
          </tab-content>
          <tab-content title="Referencias familiares">
            <family-references-form :project="project" :assignments="assignments" :family_references="family_references" :cities="cities" v-if="family_references != null && cities != null"></family-references-form>      
          </tab-content>      
          <tab-content title="Referencias personales">
            <personal-references :project="project" :assignments="assignments" :personal_references="personal_references" :cities="cities" v-if="personal_references != null && cities != null"></personal-references>
          </tab-content>
          <template slot="footer" slot-scope="props">
            <div class="wizard-footer-left">
                <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">Anterior</wizard-button>
            </div>
            <div class="row" v-if="props.activeTabIndex == 0">
              <div class="col-sm-12 text-center">
                <wizard-button v-if="!props.isLastStep"@click.native="checkNextTab()" id="button-step-one" :style="props.fillButtonStyle"><i class="fas fa-arrow-right icon-next"></i> Continuar con el siguiente paso</wizard-button>
              </div>                    
            </div>
            <div class="wizard-footer-right" v-if="props.activeTabIndex > 0">
              <wizard-button v-if="!props.isLastStep"@click.native="checkNextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Siguiente</wizard-button>

              <wizard-button v-else @click.native="finalizeForm()" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? 'Finalizar' : 'Siguiente'}}</wizard-button>
            </div>
          </template>      
        </form-wizard>  
        <legal :project="project" v-else></legal>        
      </template>
      <div class="" v-else>
        <token-invalid></token-invalid>
      </div>
    </template>
  </div>
</template>

<script>
import TokenInvalid from './token-invalid.vue'
import Legal from './legal.vue'
import AcademicReferencesForm from './academic-references-form.vue'
import BasicInformationForm from './basic-information-form.vue'
import FamilyReferencesForm from './family-references-form.vue'
import LaboraReferencesForm from './laboral-references-form.vue'
import PersonalReferences from './personal-references.vue'
import axios from "axios";
import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { mapGetters, mapMutations } from 'vuex'
import { eventBus } from './../../../application'
export default {
  props: ['project', 'assignments', 'academic_references', 'cities', 'laboral_references', 'family_references', 'personal_references', 'project_archives'],
  data() {
    return {
      typeMessage: '',
      message: '',
      viewGreeting: false,
      source: '',
      progress: 0,
      legal: false
    }
  },
  methods: {
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },    
    finalizeForm(){
      this.checkNextTab()
    },
    checkNextTab(){
      if ((this.$refs.wizard.activeTabIndex + 1) > this.progress) {
        this.progress = this.$refs.wizard.activeTabIndex + 1
        this.updateProgress()  
      }            
      switch (this.$refs.wizard.activeTabIndex) {
        case 0:
          eventBus.$emit('saveProject')          
          return 
        case 1:
          eventBus.$emit('authorizeNextTabAcademic')
          return 
        case 2:
          eventBus.$emit('authorizeNextTabLaboral')
          return 
        case 3:
          eventBus.$emit('authorizeNextTabFamily')
          return 
        case 4:
          eventBus.$emit('authorizeNextTabPersonal')
          this.setRequestCandidateDone()
          return                                         
        default:
          return
      }      
    },
    goToNextTab() {
      if (this.$refs.wizard.activeTabIndex == 4) {
        this.viewGreeting = true
      } else {
        this.$refs.wizard.nextTab()  
      }      
    },
    ...mapMutations(['changeSelects']),
    getInformationWork() {
      axios.get(`/information_work_project.json?project_id=${this.project.id}`).then(res=>{
        this.changeSelects(res.data.selects)
      })        
    },
    updateProgress() {    
      this.defaultAxios()
			axios.put(`/update_information_project`, { project: { id: this.project.id, progress_form: this.progress, source_response_candidate: this.source} })
    },
    setRequestCandidateDone() {
      this.defaultAxios()
      let currentdate = new Date(); 
			axios.put(`/update_information_project`, { project: { id: this.project.id, data_requested_response_candidate: true, data_response_date_candidate: currentdate }, update_data_requested_response_candidate: true })
    },
    changeLegal(){
      this.legal = true
    }
  },
  components: {
    'token-invalid': TokenInvalid,
    'legal': Legal,
    'academic-references-form': AcademicReferencesForm,
    'basic-information-form': BasicInformationForm,
    'family-references-form': FamilyReferencesForm,
    'laboral-references-form': LaboraReferencesForm,
    'personal-references': PersonalReferences,
    FormWizard,
    TabContent,
    WizardButton    
  },
  created () {
    if (this.project.data_requested_response_candidate){
      this.viewGreeting = true
    }
    this.getInformationWork()
    eventBus.$on('goToNextTab', dataPassed => {
      this.goToNextTab()
    })
    eventBus.$on('changeLegal', dataPassed => {
      this.changeLegal()
    })    
    let source = window.location.search.split('source=')[1]
    if (source != null) {
      this.source = source
    }    
  },
  mounted () {
    if (this.project.accept_terms != null){
      this.legal = this.project.accept_terms
    }
  },
}
</script>

<style lang="scss" scoped>

</style>